import React, { useContext } from 'react';
import { Badge } from 'antd';

import VendorContext from '@totem/components/vendors/VendorContext';
import { isNotNull } from '@totem/utilities/common';
const CountBadge = () => {
  const { data } = useContext(VendorContext);

  return (
    <Badge overflowCount={99999} count={isNotNull(data) ? data.length : 0} />
  );
};

export default CountBadge;
